(function () {
  var state = window.CatchmasterGA4 || {};
  var pushedLists = {};
  var expertAdviceImpressions = {};
  var expertAdviceViews = {};
  var checkoutInProgress = false;
  var recentAddToCart = {};
  var pendingAddToCartItems = {};
  var pendingProductFormAdds = {};
  var viewCartInProgress = false;
  var lastViewCartAt = 0;
  var upcartDrawerWasOpen = false;
  var expertAdviceTrackingVersion = 'expert_advice_v2';

  function getDataLayer() {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }

  function toNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : undefined;
  }

  function cleanParam(value, fallback) {
    value = value === undefined || value === null ? '' : String(value).trim();
    return value || fallback;
  }

  function pathHandle(pathname) {
    var path = cleanParam(pathname || window.location.pathname, '');
    var parts = path.split('/').filter(Boolean);
    return parts.length ? parts[parts.length - 1] : '';
  }

  function titleFromHandle(handle) {
    return cleanParam(handle, 'unknown').split('-').map(function (part) {
      return part.charAt(0).toUpperCase() + part.slice(1);
    }).join(' ');
  }

  function getLinkPath(link) {
    if (!link || !link.href) return '';

    try {
      return new URL(link.href, window.location.origin).pathname;
    } catch (error) {
      return '';
    }
  }

  function getArticleTitle() {
    if (state.article && state.article.article_title) return cleanParam(state.article.article_title, 'unknown_article');

    var heading = document.querySelector('main h1');
    return cleanParam(heading && heading.textContent, cleanParam(document.title, 'unknown_article'));
  }

  function getArticleTopic() {
    if (state.article && state.article.article_tag) return cleanParam(state.article.article_tag, 'unknown_topic');

    var topicLink = document.querySelector('main a[href*="/blogs/news/tagged/"], main a[href="/blogs/news"] + *');
    return cleanParam(topicLink && topicLink.textContent, 'unknown_topic');
  }

  function getArticleContext() {
    return {
      article_title: getArticleTitle(),
      article_url: cleanParam(state.article && state.article.article_url, window.location.pathname),
      article_tag: getArticleTopic(),
    };
  }

  function getNearestHeadingText(element) {
    var current = element;

    while (current && current !== document.body) {
      var previous = current.previousElementSibling;
      while (previous) {
        if (/^H[1-6]$/.test(previous.tagName)) {
          return cleanParam(previous.textContent, 'unknown_section');
        }

        var nestedHeading = previous.querySelector && previous.querySelector('h1, h2, h3, h4, h5, h6');
        if (nestedHeading) return cleanParam(nestedHeading.textContent, 'unknown_section');

        previous = previous.previousElementSibling;
      }

      current = current.parentElement;
    }

    return 'unknown_section';
  }

  function getArticleLinkType(link) {
    if (!link) return 'unknown_link';
    if (link.closest('[data-ga4-item]')) return 'product_card';
    if (link.querySelector('img')) return 'image';
    if (/read more/i.test(link.textContent || '')) return 'read_more';
    return 'text';
  }

  function getCollectionFallback() {
    return cleanParam(titleFromHandle(pathHandle()), 'unknown_collection');
  }

  function getCollectionHandleFallback() {
    return cleanParam(pathHandle(), 'unknown_collection');
  }

  function getExpertAdviceCardParams(card, link) {
    var articleTitle = cleanParam(card && card.getAttribute('data-ga4-article-title'), cleanParam(link && link.textContent, 'unknown_article'));
    var articleUrl = cleanParam(card && card.getAttribute('data-ga4-article-url'), link && getLinkPath(link) || 'unknown_url');

    return {
      collection_name: cleanParam(card && card.getAttribute('data-ga4-collection-title'), getCollectionFallback()),
      collection_handle: cleanParam(card && card.getAttribute('data-ga4-collection-handle'), getCollectionHandleFallback()),
      article_title: articleTitle,
      article_url: articleUrl,
      article_tag: cleanParam(card && card.getAttribute('data-ga4-article-tag'), 'unknown_topic'),
    };
  }

  function cleanItem(item) {
    if (!item) return null;

    var cleaned = {
      item_id: String(item.item_id || item.variant_id || item.id || ''),
      item_name: item.item_name || item.product_title || item.title || '',
      item_brand: item.item_brand || item.vendor || undefined,
      item_category: item.item_category || item.category || undefined,
      item_variant: item.item_variant || item.variant_title || undefined,
      price: toNumber(item.price),
      quantity: toNumber(item.quantity) || 1,
      index: toNumber(item.index),
      item_list_name: item.item_list_name || undefined,
    };

    if (!cleaned.item_id || !cleaned.item_name) return null;

    Object.keys(cleaned).forEach(function (key) {
      if (cleaned[key] === undefined || cleaned[key] === '') delete cleaned[key];
    });

    return cleaned;
  }

  function pushEvent(eventName, ecommerce) {
    if (!eventName || !ecommerce) return;

    getDataLayer().push({ ecommerce: null });
    getDataLayer().push({
      event: eventName,
      ecommerce: ecommerce,
    });
  }

  function pushMarketingEvent(eventName, params) {
    if (!eventName) return;

    var eventParams = Object.assign({
      page_path: window.location.pathname,
      page_title: document.title,
      tracking_version: expertAdviceTrackingVersion,
      tracking_source: 'theme',
      tracking_transport: 'data_layer',
    }, params || {});

    getDataLayer().push(Object.assign({
      event: eventName,
    }, eventParams));

    pushDirectGa4MarketingEvent(eventName, eventParams);
  }

  function pushDirectGa4MarketingEvent(eventName, params) {
    if (eventName.indexOf('expert_advice_') !== 0) return;
    if (!state.directMeasurementId) return;

    var directParams = Object.assign({}, params || {}, {
      tracking_transport: 'direct_collect',
    });
    var query = buildGa4CollectParams(eventName, directParams);
    if (!query) return;

    var url = 'https://www.google-analytics.com/g/collect?' + query;

    if (navigator.sendBeacon && navigator.sendBeacon(url)) return;

    if (window.fetch) {
      fetch(url, {
        method: 'GET',
        mode: 'no-cors',
        keepalive: true,
      }).catch(function () {});
      return;
    }

    var pixel = new Image();
    pixel.src = url;
  }

  function buildGa4CollectParams(eventName, params) {
    var clientId = getGaClientId();
    if (!clientId) return '';

    var searchParams = new URLSearchParams({
      v: '2',
      tid: state.directMeasurementId,
      cid: clientId,
      en: eventName,
      dl: window.location.href,
      dt: document.title,
      sid: getGaSessionId(),
      seg: '1',
      _p: String(Math.round(Math.random() * 2147483647)),
    });

    if (screen && screen.width && screen.height) {
      searchParams.set('sr', screen.width + 'x' + screen.height);
    }

    if (navigator.language) {
      searchParams.set('ul', navigator.language);
    }

    Object.keys(params || {}).forEach(function (key) {
      var value = params[key];
      if (value === undefined || value === null || value === '') return;
      searchParams.set('ep.' + key, String(value));
    });

    return searchParams.toString();
  }

  function getGaClientId() {
    var cookieMatch = document.cookie.match(/(?:^|;\s*)_ga=GA\d+\.\d+\.(\d+\.\d+)/);
    if (cookieMatch) return cookieMatch[1];

    try {
      var storedClientId = localStorage.getItem('catchmaster_ga4_client_id');
      if (storedClientId) return storedClientId;

      var clientId = Math.floor(Math.random() * 2147483647) + '.' + Math.floor(Date.now() / 1000);
      localStorage.setItem('catchmaster_ga4_client_id', clientId);
      return clientId;
    } catch (error) {
      return Math.floor(Math.random() * 2147483647) + '.' + Math.floor(Date.now() / 1000);
    }
  }

  function getGaSessionId() {
    var now = Math.floor(Date.now() / 1000);

    try {
      var session = JSON.parse(localStorage.getItem('catchmaster_ga4_session') || 'null');
      if (session && session.id && session.expiresAt && session.expiresAt > now) {
        session.expiresAt = now + 1800;
        localStorage.setItem('catchmaster_ga4_session', JSON.stringify(session));
        return String(session.id);
      }

      session = {
        id: now,
        expiresAt: now + 1800,
      };
      localStorage.setItem('catchmaster_ga4_session', JSON.stringify(session));
      return String(session.id);
    } catch (error) {
      return String(now);
    }
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    return String(url).indexOf('/cart/add') !== -1;
  }

  function getRequestUrl(input) {
    if (!input) return '';
    if (typeof input === 'string') return input;
    if (input.url) return input.url;
    return '';
  }

  function getCartAddRequestItem(body) {
    if (!body) return null;

    var variantId = '';
    var quantity = 1;

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      variantId = body.get('id');
      quantity = body.get('quantity');
    } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      variantId = body.get('id');
      quantity = body.get('quantity');
    } else if (typeof body === 'string') {
      try {
        var parsedBody = JSON.parse(body);
        var requestedLine = parsedBody.items && parsedBody.items[0] ? parsedBody.items[0] : parsedBody;
        variantId = requestedLine && requestedLine.id;
        quantity = requestedLine && requestedLine.quantity;
      } catch (error) {
        return null;
      }
    } else {
      return null;
    }

    variantId = cleanParam(variantId, '');
    if (!variantId) return null;

    return {
      variant_id: variantId,
      quantity: toNumber(quantity) || 1,
    };
  }

  function pushAddToCart(item) {
    if (!item) return;

    var key = item.item_id + ':' + item.quantity;
    var now = Date.now();
    if (recentAddToCart[key] && now - recentAddToCart[key] < 1500) return;
    recentAddToCart[key] = now;

    pushEvent('add_to_cart', {
      currency: state.currency,
      value: item.price * item.quantity,
      items: [item],
    });
  }

  function mergeItemFallback(item, fallback) {
    if (!item) return fallback || null;
    if (!fallback) return item;

    if (!item.item_category && fallback.item_category) item.item_category = fallback.item_category;
    if (!item.item_list_name && fallback.item_list_name) item.item_list_name = fallback.item_list_name;
    if (item.index === undefined && fallback.index !== undefined) item.index = fallback.index;
    return item;
  }

  function ajaxItemToGa4(item, fallback) {
    if (!item) return null;

    return mergeItemFallback(cleanItem({
      item_id: item.sku || item.variant_id || item.id,
      item_name: item.product_title || item.title,
      item_brand: item.vendor,
      item_category: item.product_type,
      item_variant: item.variant_title,
      price: item.final_price !== undefined ? item.final_price / 100 : item.price / 100,
      quantity: item.quantity,
    }), fallback);
  }

  function getCardItem(card, index) {
    if (!card) return null;

    return cleanItem({
      item_id: card.getAttribute('data-ga4-item-id'),
      item_name: card.getAttribute('data-ga4-item-name'),
      item_brand: card.getAttribute('data-ga4-item-brand'),
      item_category: card.getAttribute('data-ga4-item-category'),
      item_variant: card.getAttribute('data-ga4-item-variant'),
      item_list_name: card.getAttribute('data-ga4-list-name'),
      price: card.getAttribute('data-ga4-price'),
      quantity: 1,
      index: index,
    });
  }

  function getSelectedProductForm() {
    return document.querySelector('main product-form form[action*="/cart/add"], main form[action*="/cart/add"]');
  }

  function getProductVariantItem(variantId) {
    variantId = cleanParam(variantId, '');
    var variant = variantId && state.productVariants && state.productVariants[variantId];
    if (!variant || !state.product) return null;

    return cleanItem(Object.assign({}, state.product, variant));
  }

  function getSelectedProductItem() {
    var selectedItem = getProductVariantItem(getVariantInputValue(getSelectedProductForm()));
    return selectedItem || cleanItem(state.product);
  }

  function getFormItem(form) {
    if (!form) return null;

    var card = form.closest('[data-ga4-item]');
    var item = getCardItem(card);
    if (!item && state.product && form.closest('main')) item = getProductVariantItem(getVariantInputValue(form)) || cleanItem(state.product);
    if (!item) return null;

    var quantityInput = form.querySelector('[name="quantity"]');
    item.quantity = toNumber(quantityInput && quantityInput.value) || item.quantity || 1;
    return item;
  }

  function getVariantInputValue(form) {
    var variantInput = form && form.querySelector('[name="id"]');
    return cleanParam(variantInput && variantInput.value, '');
  }

  function recordPendingAddToCart(form) {
    var variantId = getVariantInputValue(form);
    if (!variantId) return;

    var item = getFormItem(form);
    if (!item) return;
    pendingAddToCartItems[variantId] = item;
  }

  function getPendingAddToCartItem(variantId) {
    variantId = cleanParam(variantId, '');
    return variantId ? pendingAddToCartItems[variantId] : null;
  }

  function applyRequestedQuantity(item, requestedItem) {
    if (!item || !requestedItem) return item;

    var requestedQuantity = toNumber(requestedItem.quantity);
    if (!requestedQuantity) return item;

    var requestedVariantId = cleanParam(requestedItem.variant_id, '');
    var itemVariantId = cleanParam(item.variant_id, '');
    if (requestedVariantId && itemVariantId && requestedVariantId !== itemVariantId) return item;

    item.quantity = requestedQuantity;
    return item;
  }

  // A <product-form> submit (PDP add-to-cart, quick-add-modal) always publishes
  // PUB_SUB_EVENTS.cartUpdate on success, which trackAddToCartFromCartUpdate
  // already turns into an add_to_cart push. The global fetch/XHR interception
  // below also observes that same /cart/add response and would otherwise push
  // a second, redundant add_to_cart for it. Mark the variant here (synchronously,
  // at submit time) so the interception path can skip it instead of relying on
  // the two async paths happening to compute an identical dedup key.
  function markPendingProductFormAdd(variantId) {
    variantId = cleanParam(variantId, '');
    if (!variantId) return;
    pendingProductFormAdds[variantId] = Date.now();
  }

  // Consumes (and clears) a pending product-form mark for this variant if one
  // was recorded recently. The age check guards against a stale mark left
  // behind when product-form.js hit its error branch and never published
  // cartUpdate (e.g. a sold-out response) — in that case the interception path
  // should still be free to report a later, unrelated add for the same variant.
  function consumePendingProductFormAdd(variantId) {
    variantId = cleanParam(variantId, '');
    if (!variantId) return false;
    var markedAt = pendingProductFormAdds[variantId];
    if (!markedAt) return false;
    delete pendingProductFormAdds[variantId];
    return Date.now() - markedAt < 10000;
  }

  function trackViewItem() {
    if (!state.product) return;

    var item = getSelectedProductItem();
    if (!item) return;

    pushEvent('view_item', {
      currency: state.currency,
      value: item.price,
      items: [item],
    });
  }

  function trackViewItemLists() {
    var cards = getVisibleGa4Cards();
    if (!cards.length) return;

    var grouped = {};
    cards.forEach(function (card, index) {
      var item = getCardItem(card, index + 1);
      if (!item) return;

      var listName = item.item_list_name || 'Product List';
      if (!grouped[listName]) grouped[listName] = [];
      grouped[listName].push(item);
    });

    Object.keys(grouped).forEach(function (listName) {
      if (pushedLists[listName]) return;
      pushedLists[listName] = true;

      pushEvent('view_item_list', {
        item_list_name: listName,
        items: grouped[listName],
      });
    });
  }

  function trackSelectItem(event) {
    var link = event.target.closest('a[href]');
    if (!link) return;

    var card = link.closest('[data-ga4-item]');
    if (!card) return;

    var cards = getVisibleGa4Cards();
    var item = getCardItem(card, cards.indexOf(card) + 1);
    if (!item) return;

    pushEvent('select_item', {
      item_list_name: item.item_list_name || 'Product List',
      items: [item],
    });
  }

  function isVisibleGa4Item(card) {
    if (!card || card.closest('[hidden], [aria-hidden="true"], .hidden')) return false;

    var current = card;
    while (current && current !== document.documentElement) {
      var style = window.getComputedStyle && window.getComputedStyle(current);
      if (style && (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse')) return false;
      current = current.parentElement;
    }

    return true;
  }

  function getVisibleGa4Cards() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ga4-item]')).filter(isVisibleGa4Item);
  }

  function bindProductTabLists() {
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.tabs-slider-product-tabs [data-tab]')) return;
      window.setTimeout(trackViewItemLists, 0);
    }, true);

    document.addEventListener('keydown', function (event) {
      if (['ArrowRight', 'ArrowLeft', 'Home', 'End'].indexOf(event.key) === -1) return;
      if (!event.target.closest('.tabs-slider-product-tabs [data-tab]')) return;
      window.setTimeout(trackViewItemLists, 0);
    }, true);
  }

  function trackExpertAdviceTab(event) {
    var tab = event.target.closest('[data-ga4-expert-advice-tab]');
    if (!tab) return;

    var collectionHandle = cleanParam(tab.getAttribute('data-ga4-collection-handle'), getCollectionHandleFallback());
    if (expertAdviceViews[collectionHandle]) return;
    expertAdviceViews[collectionHandle] = true;

    pushMarketingEvent('expert_advice_view', {
      collection_name: cleanParam(tab.getAttribute('data-ga4-collection-title'), getCollectionFallback()),
      collection_handle: collectionHandle,
      section_id: cleanParam(tab.getAttribute('data-section-id'), 'unknown_section'),
    });
  }

  function trackExpertAdviceClick(event) {
    var link = event.target.closest('[data-ga4-expert-advice-link]');
    if (!link) return;

    var card = link.closest('[data-ga4-expert-advice-card]');
    if (!card) return;

    pushMarketingEvent('expert_advice_click', Object.assign(getExpertAdviceCardParams(card, link), {
      link_type: cleanParam(link.getAttribute('data-ga4-link-type'), 'unknown_link'),
    }));
  }

  function trackExpertAdviceImpression(card, index) {
    var params = getExpertAdviceCardParams(card);
    var key = [
      params.collection_handle,
      params.article_url,
      index,
    ].join(':');

    if (expertAdviceImpressions[key]) return;
    expertAdviceImpressions[key] = true;

    pushMarketingEvent('expert_advice_impression', Object.assign(params, {
      card_position: index,
    }));
  }

  function bindExpertAdviceImpressions() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-ga4-expert-advice-card]'));
    if (!cards.length || !window.IntersectionObserver) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var card = entry.target;
        var index = cards.indexOf(card) + 1;
        trackExpertAdviceImpression(card, index);
        observer.unobserve(card);
      });
    }, {
      threshold: 0.4,
    });

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  function isArticlePage() {
    return state.template === 'article' || window.location.pathname.indexOf('/blogs/news/') === 0;
  }

  function getArticleClickParams(link, destinationType) {
    var linkPath = getLinkPath(link);
    var linkHandle = pathHandle(linkPath);

    return Object.assign(getArticleContext(), {
      destination_type: destinationType,
      destination_url: cleanParam(linkPath, 'unknown_url'),
      destination_label: cleanParam(link && link.textContent, titleFromHandle(linkHandle)),
      destination_handle: cleanParam(linkHandle, 'unknown_destination'),
      link_type: getArticleLinkType(link),
      link_section: getNearestHeadingText(link),
    });
  }

  function isShopIntentPagePath(path) {
    return path.indexOf('/pages/best-') === 0 || path.indexOf('/pages/landing-page') === 0;
  }

  function trackExpertAdviceArticleShopClick(event) {
    if (!isArticlePage()) return;

    var link = event.target.closest('a[href]');
    if (!link || !link.closest('main')) return;

    var linkPath = getLinkPath(link);
    if (linkPath.indexOf('/products/') === 0) {
      pushMarketingEvent('expert_advice_article_product_click', getArticleClickParams(link, 'product'));
      return;
    }

    if (linkPath.indexOf('/collections/') === 0) {
      pushMarketingEvent('expert_advice_article_collection_click', getArticleClickParams(link, 'collection'));
      return;
    }

    if (isShopIntentPagePath(linkPath)) {
      pushMarketingEvent('expert_advice_article_cta_click', getArticleClickParams(link, 'page'));
    }
  }

  function trackExpertAdviceArticleAddToCart(event) {
    if (!isArticlePage()) return;

    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]') || !form.closest('main')) return;

    var variantInput = form.querySelector('[name="id"]');
    pushMarketingEvent('expert_advice_article_add_to_cart', Object.assign(getArticleContext(), {
      destination_type: 'add_to_cart',
      variant_id: cleanParam(variantInput && variantInput.value, 'unknown_variant'),
      link_section: getNearestHeadingText(form),
    }));
  }

  function trackAddToCartFromCartUpdate(event) {
    if (!event || event.source !== 'product-form' || !event.cartData) return;

    var requestedItem = getPendingAddToCartItem(event.productVariantId);
    var item = ajaxItemToGa4(event.cartData, requestedItem);
    applyRequestedQuantity(item, requestedItem);
    pushAddToCart(item);
  }

  function trackAddToCartSubmit(event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;
    recordPendingAddToCart(form);
    if (form.closest('product-form')) {
      // This submit will resolve through product-form.js's own fetch, which
      // publishes cartUpdate on success (see trackAddToCartFromCartUpdate).
      // Mark it so the fetch/XHR interception below doesn't also count it.
      markPendingProductFormAdd(getVariantInputValue(form));
      return;
    }

    var item = getFormItem(form);
    if (!item) return;

    pushAddToCart(item);
  }

  function trackCartAddResponse(data, requestedItem) {
    if (!data) return;

    var items = data.items && Array.isArray(data.items) ? data.items : [data];
    items.forEach(function (lineItem) {
      var variantId = lineItem && lineItem.variant_id;
      if (consumePendingProductFormAdd(variantId)) return;
      var pendingItem = getPendingAddToCartItem(variantId);
      var item = ajaxItemToGa4(lineItem, pendingItem);
      applyRequestedQuantity(item, pendingItem || requestedItem);
      pushAddToCart(item);
    });
  }

  function bindFetchCartAdd() {
    if (!window.fetch || window.fetch.__catchmasterGa4Patched) return;

    var originalFetch = window.fetch;
    window.fetch = function () {
      var requestUrl = getRequestUrl(arguments[0]);
      var requestedItem = getCartAddRequestItem(arguments[1] && arguments[1].body);
      return originalFetch.apply(this, arguments).then(function (response) {
        if (isCartAddUrl(requestUrl) && response && response.ok) {
          response.clone().json().then(function (data) {
            trackCartAddResponse(data, requestedItem);
          }).catch(function () {});
        }
        return response;
      });
    };
    window.fetch.__catchmasterGa4Patched = true;
  }

  function bindXhrCartAdd() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.__catchmasterGa4Patched) return;

    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__catchmasterGa4Url = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      this.__catchmasterGa4RequestItem = getCartAddRequestItem(body);
      this.addEventListener('load', function () {
        if (!isCartAddUrl(this.__catchmasterGa4Url) || this.status < 200 || this.status >= 300) return;

        try {
          trackCartAddResponse(JSON.parse(this.responseText), this.__catchmasterGa4RequestItem);
        } catch (error) {}
      });

      return originalSend.apply(this, arguments);
    };

    window.XMLHttpRequest.__catchmasterGa4Patched = true;
  }

  function cartItemToGa4(item) {
    if (!item) return null;

    return cleanItem({
      item_id: item.sku || item.variant_id || item.id,
      item_name: item.product_title || item.title,
      item_brand: item.vendor,
      item_category: item.product_type,
      item_variant: item.variant_title,
      price: item.final_price !== undefined ? item.final_price / 100 : item.price / 100,
      quantity: item.quantity,
    });
  }

  function fetchCart() {
    if (!window.routes || !window.routes.cart_url) return Promise.resolve(null);

    return fetch(window.routes.cart_url + '.js', {
      headers: {
        Accept: 'application/json',
      },
    }).then(function (response) {
      return response.ok ? response.json() : null;
    }).catch(function () {
      return null;
    });
  }

  function pushCartEvent(eventName, cart) {
    var items = cart && cart.items ? cart.items.map(cartItemToGa4).filter(Boolean) : [];
    var value = cart && cart.total_price !== undefined ? cart.total_price / 100 : undefined;

    pushEvent(eventName, {
      currency: state.currency,
      value: value,
      items: items,
    });
  }

  function isCartPage() {
    return state.template === 'cart' || window.location.pathname.replace(/\/+$/, '') === '/cart';
  }

  function trackViewCart() {
    var now = Date.now();
    if (viewCartInProgress || now - lastViewCartAt < 1500) return;

    viewCartInProgress = true;
    lastViewCartAt = now;

    fetchCart().then(function (cart) {
      if (!cart) return;
      pushCartEvent('view_cart', cart);
    }).finally(function () {
      viewCartInProgress = false;
    });
  }

  function bindViewCart() {
    if (isCartPage()) trackViewCart();
    document.addEventListener('catchmaster:cart-drawer-opened', trackViewCart);
  }

  // bindViewCart() covers the native <cart-drawer> and the cart page. For
  // ordinary shoppers the storefront renders the real UpCart app-embed widget
  // instead (no <cart-drawer> ever appears). Detect the UpCart drawer's own
  // open/close visibility state and emit view_cart once per open, reusing the
  // existing trackViewCart() debounce.
  //
  // Scoping: isNativeCartMode() (assets/custom.js) is the same signal the
  // theme's own UpCart accessibility patches use to stay out of the native
  // cart-drawer experiment arms. Skip entirely whenever it reports a native
  // arm (or a <cart-drawer> is present) so this never runs alongside — and
  // never duplicates — the experiment's own view_cart handling.
  function isNativeCartExperiment() {
    if (document.querySelector('cart-drawer')) return true;
    return typeof window.isNativeCartMode === 'function' && window.isNativeCartMode();
  }

  function getUpcartDrawer() {
    return document.getElementById('CartPopup') ||
      document.getElementById('UpcartPopup') ||
      document.querySelector('.upcart-popup, .upcart-drawer');
  }

  function isUpcartDrawerOpen(drawer) {
    if (!drawer) return false;

    if (/^(CartPopup|UpcartPopup)$/i.test(drawer.id || '')) {
      return Array.prototype.some.call(drawer.classList, function (className) {
        return /active/i.test(className);
      });
    }

    // Note: offsetParent is unreliable here — UpCart's drawer is a fixed-position
    // overlay, and offsetParent is null for position:fixed elements regardless of
    // visibility, which would make this always report "closed". Use layout size
    // and computed style instead, which work for any positioning scheme.
    var rect = drawer.getBoundingClientRect();
    if (!rect.width || !rect.height) return false;

    var style = window.getComputedStyle && window.getComputedStyle(drawer);
    if (style && (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0)) return false;

    return true;
  }

  function bindUpcartViewCart() {
    if (!window.MutationObserver) return;

    var scopedObserver = null;
    var waitingObserver = null;
    var pendingCheck = null;

    function disconnectAll() {
      if (scopedObserver) {
        scopedObserver.disconnect();
        scopedObserver = null;
      }
      if (waitingObserver) {
        waitingObserver.disconnect();
        waitingObserver = null;
      }
      if (pendingCheck) {
        window.clearTimeout(pendingCheck);
        pendingCheck = null;
      }
    }

    function checkUpcartDrawer() {
      if (isNativeCartExperiment()) {
        upcartDrawerWasOpen = false;
        disconnectAll();
        return;
      }

      var isOpen = isUpcartDrawerOpen(getUpcartDrawer());
      if (isOpen && !upcartDrawerWasOpen) trackViewCart();
      upcartDrawerWasOpen = isOpen;
    }

    // Coalesce mutation bursts (UpCart re-renders its footer/contents on every
    // cart change) into a single getBoundingClientRect()/getComputedStyle()
    // check instead of one per mutation record, to avoid layout thrashing.
    function scheduleCheck() {
      if (pendingCheck) return;
      pendingCheck = window.setTimeout(function () {
        pendingCheck = null;
        checkUpcartDrawer();
      }, 100);
    }

    // Attach the observer to the UpCart drawer's own wrapper (a stable node
    // that persists across the drawer's internal re-renders) rather than
    // document.documentElement, so mutations anywhere else on the page never
    // trigger a check.
    function attachToUpcartRoot() {
      var drawer = getUpcartDrawer();
      if (!drawer) return false;

      var root = drawer.closest('.upcart-wrapper') || drawer.parentElement || drawer;
      if (scopedObserver) return true;

      scopedObserver = new MutationObserver(scheduleCheck);
      scopedObserver.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'open'],
      });
      return true;
    }

    checkUpcartDrawer();
    if (isNativeCartExperiment()) return;

    if (attachToUpcartRoot()) return;

    // UpCart's app-embed can inject its markup after this script runs. Watch
    // only for new elements landing on the body (no attribute/subtree churn)
    // until the drawer root shows up, then re-scope to it.
    waitingObserver = new MutationObserver(function () {
      if (isNativeCartExperiment()) {
        disconnectAll();
        return;
      }

      if (attachToUpcartRoot()) {
        waitingObserver.disconnect();
        waitingObserver = null;
        scheduleCheck();
      }
    });

    waitingObserver.observe(document.body, { childList: true });
  }

  // Re-resolve the live form at submit time. The cart drawer re-renders its footer
  // (and therefore the checkout button + form) on cart changes, so a form reference
  // captured at click time can be detached by the time we submit — submitting a
  // detached node is a silent no-op that strands the shopper. Prefer the button's
  // form attribute / closest live form over the captured one.
  function resolveCheckoutForm(form, button) {
    if (form && form.isConnected) return form;
    if (button) {
      var formId = button.getAttribute && button.getAttribute('form');
      if (formId) {
        var byId = document.getElementById(formId);
        if (byId && byId.isConnected && byId.tagName === 'FORM') return byId;
      }
      if (button.form && button.form.isConnected) return button.form;
      if (button.closest) {
        var parentForm = button.closest('form');
        if (parentForm && parentForm.isConnected) return parentForm;
      }
    }
    return null;
  }

  function resolveCheckoutUrl(button) {
    if (button && button.getAttribute) {
      var href = button.getAttribute('href');
      if (href) return href;
    }

    // Keep a localized storefront prefix when routes.cart_url includes one
    // (for example, /en/cart -> /en/checkout).
    var cartUrl = window.routes && window.routes.cart_url;
    if (cartUrl) {
      var checkoutUrl = cartUrl.replace(/\/cart\/?$/, '/checkout');
      if (checkoutUrl !== cartUrl) return checkoutUrl;
    }

    return '/checkout';
  }

  function submitCheckout(form, button) {
    var liveForm = resolveCheckoutForm(form, button);
    if (liveForm) {
      try {
        var name = button && button.name;
        if (name && !liveForm.querySelector('input[name="' + name + '"]')) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = (button && button.value) || '';
          liveForm.appendChild(input);
        }
        HTMLFormElement.prototype.submit.call(liveForm);
        return;
      } catch (error) {
        // Fall through to direct navigation so analytics or form failures can
        // never leave a prevented checkout click stranded on the cart.
      }
    }

    window.location.assign(resolveCheckoutUrl(button));
  }

  function trackBeginCheckout(event) {
    var button = event.target.closest('button[name="checkout"], input[name="checkout"], .upcart-checkout-button, [href*="/checkout"]');
    if (!button) return;

    // Suppress the button's default action on every matching click, even one
    // that arrives while a checkout is already in flight. Otherwise a fast
    // double-click/double-tap lets the second click's native form submission
    // (or link navigation) race ahead of the first click's pending
    // begin_checkout push, navigating away before GA4 can record the event.
    event.preventDefault();

    if (checkoutInProgress) return;

    var form = button.form || (button.closest && button.closest('form'));
    checkoutInProgress = true;

    var done = false;
    function proceed() {
      if (done) return;
      done = true;
      submitCheckout(form, button);
    }

    // Safety net: analytics must never block navigation. If fetchCart hangs, submit anyway.
    var fallbackTimer = setTimeout(proceed, 700);

    fetchCart().then(function (cart) {
      pushCartEvent('begin_checkout', cart);
    }).finally(function () {
      clearTimeout(fallbackTimer);
      proceed();
    });
  }

  function bindCartUpdate() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, trackAddToCartFromCartUpdate);
  }

  function init() {
    trackViewItem();
    trackViewItemLists();
    bindFetchCartAdd();
    bindXhrCartAdd();
    bindCartUpdate();
    bindViewCart();
    bindUpcartViewCart();
    bindProductTabLists();
    bindExpertAdviceImpressions();

    document.addEventListener('click', trackSelectItem, true);
    document.addEventListener('click', trackExpertAdviceTab, true);
    document.addEventListener('click', trackExpertAdviceClick, true);
    document.addEventListener('click', trackExpertAdviceArticleShopClick, true);
    document.addEventListener('submit', trackExpertAdviceArticleAddToCart, true);
    document.addEventListener('submit', trackAddToCartSubmit, true);
    document.addEventListener('click', trackBeginCheckout, true);
    window.addEventListener('pageshow', function () {
      // Keep repeat clicks suppressed until checkout navigation completes, then
      // allow a new attempt if the shopper returns through browser history.
      checkoutInProgress = false;
    });

    document.addEventListener('shopify:section:load', trackViewItemLists);
    document.addEventListener('shopify:section:load', bindExpertAdviceImpressions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
